import React from 'react';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = () => {
  return (
    <>
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-10 mx-auto">
                        <div className="row">
                            <div className="col-6 col-lg-3">
                                <h2>Comapy</h2>
                                <ul>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-6 col-lg-3">
                                <h2>Comapy</h2>
                                <ul>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-6 col-lg-3">
                                <h2>Comapy</h2>
                                <ul>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                    <li>
                                        <a href="#">About</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-6 col-lg-3">
                                <h2>Follow Us</h2>
                                <div className="row">
                                    <div className="col-3 mx-auto">
                                        <a href="https://www.instagram.com/rabikrishnayadav/">
                                            <i className='fab fa-instagram fontawesome-style'></i>
                                        </a>
                                    </div>
                                    
                                    <div className="col-3 mx-auto">
                                        <a href="http://www.linkedin.com/RabiKrishnaYadav">
                                            <i className='fab fa-linkedin fontawesome-style'></i>
                                        </a>
                                    </div>
                                    <div className="col-3 mx-auto">
                                        <a href="https://github.com/rabikryadav">
                                            <i className='fab fa-github fontawesome-style'></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="mt-5">
                            <p className='main-hero-para text-center'>Copyright @ 2022 VidsikPay. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </>
  );
};

export default Footer;